const $ = require('jquery');
const MENU_BREAKPOINT = 1000;
const STORE_OPEN_CLASS = 'js-shop-open';
const SEARCH_OPEN_CLASS = 'js-search-open';

// search vars
const SEARCH_BUTTON = '.js-search';
const SEARCH_FORM = '#block-searchform';
let SEARCH_OPEN = false;

// shop vars
const SHOP_MENU = '#block-mainnavigation';
const SHOP_BUTTON = '.js-cart';
let SHOP_OPEN = false;

// menu button
const MENU_BUTTON = '.menu-button';

// click function for search
$(SEARCH_BUTTON)
  .click((e) => {
    e.preventDefault();
    // close menu or shop if open
    checkIfMenuOpen();
    checkIfShopOpen();
    // toggle the search form
    // $(SEARCH_FORM).slideToggle();
    SEARCH_OPEN = !SEARCH_OPEN;
    if (SEARCH_OPEN) {
      $('body').addClass(SEARCH_OPEN_CLASS);
      $('.search-block-form input#edit-keys').focus();
    } else {
      $('body').removeClass(SEARCH_OPEN_CLASS);
    }
  })

// click function for search
$(SHOP_BUTTON).click((e) => {
  e.preventDefault();
  // close menu or search if open
  checkIfMenuOpen();
  checkIfSearchOpen();
  // toggle the search
  $(SHOP_MENU).slideToggle();
  SHOP_OPEN = !SHOP_OPEN;
  if (SHOP_OPEN) {
    $('body').addClass(STORE_OPEN_CLASS);
  } else {
    $('body').removeClass(STORE_OPEN_CLASS);
  }
});


$(MENU_BUTTON).click((e) => {
  // close the search or shop if open
  checkIfSearchOpen();
  checkIfShopOpen();
});

//add tabindex to make menu items focusable
$('.main-menu li.is-parent, .js-search').attr('tabindex', 0);

// handle focus toggling
$('.main-menu li.is-parent')
  .focusin( e => {
    const focusedEl = $(e.currentTarget);
    // $('.main-menu li.is-parent').removeClass('focused');
    focusedEl.addClass('focused')
  })
  .focusout( e => {
    const focusedEl = $(e.currentTarget);
    // check if we're still in the menu or not
    if(focusedEl.parents('li.is-parent.focused').length < 1){
      // we've moved outside, so remove the focused class
      $('.main-menu li.is-parent.focused').removeClass('focused');
    }
  })
  .mouseleave( e => {
    const focusedEl = $(e.currentTarget);
    // check if we're still in the menu or not
    if(focusedEl.parents('li.is-parent.focused').length < 1){
      // we've moved outside, so remove the focused class
      $('.main-menu li.is-parent.focused').removeClass('focused');
    }
  });


// will close menu if it's open
function checkIfMenuOpen() {
  if ($('body').hasClass('js-menu-open')) {
    // if the menu's open, close it
    $(MENU_BUTTON).click();
  }
}

// will close menu if it's open
function checkIfSearchOpen() {
  if (SEARCH_OPEN) {
    // if the search's open, close it
    $(SEARCH_FORM).slideUp();
    SEARCH_OPEN = !SEARCH_OPEN;
    $('body').removeClass(SEARCH_OPEN_CLASS);
  }
}

// will close menu if it's open
function checkIfShopOpen() {
  if (SHOP_OPEN) {
    // if the search's open, close it
    $(SHOP_MENU).slideUp();
    SHOP_OPEN = !SHOP_OPEN;
    $('body').removeClass(STORE_OPEN_CLASS);
  }
}
